import { render, staticRenderFns } from "./IrisPayModalPopup.vue?vue&type=template&id=7758088d&scoped=true&"
import script from "./IrisPayModalPopup.vue?vue&type=script&lang=js&"
export * from "./IrisPayModalPopup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=7758088d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7758088d",
  null
  
)

export default component.exports